import { render, staticRenderFns } from "./FiltrosExternaArmazem.vue?vue&type=template&id=cdad8910&"
import script from "./FiltrosExternaArmazem.vue?vue&type=script&lang=js&"
export * from "./FiltrosExternaArmazem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports